
const linksList = [
	{
		title: "Clientes",
		// caption: 'quasar.dev',
		icon: "groups",
		link: "/Clientes",
	},
];

import { defineComponent, ref } from "vue";
import { getAuth } from "firebase/auth";
import apiServices from "../utils/apiServices";


export default defineComponent({
	name: "MainLayout",
	components: {},

	setup() {
		const leftDrawerOpen = ref(false);

		const arrOpciones = ref([]);

		return {
			essentialLinks: linksList,
			leftDrawerOpen,
			toggleLeftDrawer() {
				leftDrawerOpen.value = !leftDrawerOpen.value;
			},
			arrOpciones,
		};
	},
	methods: {
		cerrarSession: function () {
			getAuth()
				.signOut()
				.then(() => {
					this.$router.push("/login");
				});
		},
		obtenerOpciones: async function () {
			const ResOp = await apiServices.RolesOpciones();
			this.arrOpciones = { ...ResOp.data.data };
		},
	},
	async beforeMount() {
		await this.obtenerOpciones();
	},
});
